import { Card } from "@/components/ui/card"

export function ValuesSection() {
  const values = [
    {
      title: "Discipline First",
      description: "Professional mindset from day one",
    },
    {
      title: "Excellence",
      description: "World-class training standards",
    },
    {
      title: "Integrity",
      description: "Character before contracts",
    },
    {
      title: "Opportunity",
      description: "Talent over background",
    },
    {
      title: "Global Exposure",
      description: "International readiness",
    },
  ]

  return (
    <section id="values" className="py-20 bg-ivory">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gold/20 text-navy text-sm font-medium uppercase tracking-wider mb-4">
            ⚽ Our Football Philosophy
          </div>
          <h2 className="text-4xl sm:text-5xl font-semibold text-navy tracking-tight mb-6">
            What ZOE Football Academy Stands For
          </h2>
          <p className="text-xl text-navy/70">
            ZOE Football Academy is not built on hype. It is built on formation before performance.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6">
          {values.map((value, index) => (
            <Card
              key={index}
              className="p-8 bg-muted border-none hover:shadow-lg transition-shadow duration-300"
            >
              <div className="space-y-3">
                <h3 className="text-xl font-semibold text-navy">
                  {value.title}
                </h3>
                <p className="text-navy/70 leading-relaxed">
                  {value.description}
                </p>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  )
}
